import { useState, useMemo, useRef, useContext, useEffect } from 'react';
import _ from 'underscore';
import { ToastContext } from "../../../context/ToastContext.js";
import services from "../../../services/services.js";
import { Urls } from "../../../services/Urls.js";




export const useOutpasslist = ({filterValues}) => {
    const { showSuccess, showError, } = useContext(ToastContext);
    const [tabsList, settabsList] = useState([])
    const tagRef = useRef(null);
    const [status, setstatus] = useState('pending')
    const [loader, setLoader] = useState(true)
    const [showIcons, setshowIcons] = useState(true)

    useEffect(() => {
        getGatepassRequestListDetails(status)
    }, [])

    const getGatepassRequestListDetails = async (data) => {
        settabsList([])
        let list = []
        const payload = {
            is_pending: data === 'pending' ? true : false
        };
        setLoader(true)
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETGATEPASSREQUESTLISTDETAILS"), payload)
            if (res.body.data) {
                settabsList(res?.body?.data?.gatepass_request_data);
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error, "Error");
        }

    }

    const handleUpsertGatepassRequest = async (data, status) => {
        const payload = {
            "gate_pass_id": data.gate_pass_id,
            "is_approved": status === 'is_approved' ? true : false,
            "is_rejected": status === 'is_rejected' ? true : false
        };

        try {
            const res = await services.getInvokeRemote("POST", Urls("UPSERTGATEPASSREQUESTACCEPTREJECT"), payload)
            if (res.body.data) {
                showSuccess('Success', res.body.message)
                getGatepassRequestListDetails('pending')
            }
            else if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 || res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            }

        } catch (error) {
            console.error(error, "Error");
            showError("Error", error?.response?.data?.errorMessage);
        }

    }

    const handleStatus = (data) => {        
        if (data === 'pending') {
            setshowIcons(true)
        } else {
            setshowIcons(false)
        }
        settabsList([]);  
        setstatus(data)
        getGatepassRequestListDetails(data)
    }

    return useMemo(() => ({ tagRef, handleStatus, loader, tabsList, showIcons, handleUpsertGatepassRequest, status }), [tagRef, handleStatus, loader, tabsList, showIcons, handleUpsertGatepassRequest, status])
}